<template>
    <div>
        <Popup ref="popup" :minWidth="320" :minHeight="300" :is-show="isVisible" :isShowClose="true" @closed="closePopup" title="Xác thực OTP" :height="verifyOTP ? '550px' : ($app.userInfo.user_role.value === 0 ? '350px' : '260px')" :width="$app.isMobile ? '95%' : '460px'" :isShowOverlay="true">
            <template slot="body">
                 <div class="p-4 md:p-6 flex flex-col items-center justify-center h-full">
                    <!-- STANDARD VERIFY VIEW (Not Setup Phase or Setup Complete) -->
                    <div class="w-full text-center" :class="{ 'mb-6': $app.userInfo.user_role.value === 0 }" v-if="!verifyOTP">
                        <p class="text-gray-500 text-sm mb-3">Vui lòng mở ứng dụng Google Authenticator và nhập mã xác thực có 6 chữ số.</p>
                        <input 
                            type="text" 
                            v-model="otpCode" 
                            placeholder="••••••"
                            maxlength="6"
                            class="w-full max-w-[280px] h-14 text-center text-3xl tracking-[0.5em] indent-[0.5em] font-bold text-gray-800 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent transition-all shadow-inner placeholder-gray-300"
                        />
                    </div>
                    
                    <!-- 2FA SETUP VIEW (First Time Setup) -->
                    <div class="w-full text-center flex flex-col items-center animate-popupFadeIn" :class="{ 'mb-6': $app.userInfo.user_role.value === 0 }" v-else>
                        <p class="text-gray-600 text-[15px] mb-4 font-medium flex items-center justify-center gap-2">
                            <font-awesome-icon :icon="['fas', 'qrcode']" class="text-brand text-lg" /> Quét mã QR để thiết lập ứng dụng
                        </p>
                        
                        <div class="bg-white p-3 rounded-2xl shadow-sm border border-gray-200 mb-5 relative group overflow-hidden">
                            <div class="absolute inset-0 bg-brand/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            <img :src="qrCode" class="w-[180px] h-[180px] object-cover rounded-xl relative z-10" />
                        </div>
                        
                        <div class="w-full max-w-[320px] mb-5">
                            <p class="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-2">Hoặc nhập mã khóa bí mật</p>
                            <div class="bg-gray-50 border border-gray-200 rounded-xl p-3 flex items-center justify-between group/secret hover:border-brand/40 transition-colors">
                                <span class="font-mono text-[14px] text-gray-800 tracking-widest font-bold">{{ secret }}</span>
                                <button class="text-gray-400 hover:text-brand transition-colors p-1" title="Sao chép" @click="copySecret()">
                                    <font-awesome-icon :icon="['fas', 'copy']" />
                                </button>
                            </div>
                        </div>

                        <div class="w-full bg-blue-50/50 border border-brand/10 p-4 rounded-xl">
                            <p class="text-gray-600 text-sm mb-3 font-medium">Nhập mã 6 số từ ứng dụng để hoàn tất thiết lập:</p>
                            <input 
                                type="text" 
                                v-model="otpCode" 
                                placeholder="••••••"
                                maxlength="6"
                                class="w-full max-w-[280px] h-12 text-center text-2xl tracking-[0.4em] indent-[0.4em] font-bold text-gray-800 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent transition-all shadow-sm placeholder-gray-300"
                            />
                        </div>
                    </div>
                    
                    <div v-if="$app.userInfo.user_role.value === 0" class="w-full">
                        <div class="flex flex-col md:flex-row gap-3 w-full mb-4">
                            <label class="flex-1 relative flex items-center p-3 rounded-xl border cursor-pointer hover:bg-gray-50 transition-colors"
                                :class="{ 'border-brand bg-brand/5 ring-1 ring-brand': typePaymentStatus === '0', 'border-gray-200': typePaymentStatus !== '0' }">
                                <input type="radio" class="w-4 h-4 text-brand bg-gray-100 border-gray-300 focus:ring-brand" value="0" v-model="typePaymentStatus">
                                <span class="ml-2 text-sm font-medium text-gray-900">Chi ngay</span>
                            </label>
                            
                            <label class="flex-1 relative flex items-center p-3 rounded-xl border cursor-pointer hover:bg-gray-50 transition-colors"
                                :class="{ 'border-brand bg-brand/5 ring-1 ring-brand': typePaymentStatus === '1', 'border-gray-200': typePaymentStatus !== '1' }">
                                <input type="radio" class="w-4 h-4 text-brand bg-gray-100 border-gray-300 focus:ring-brand" value="1" v-model="typePaymentStatus">
                                <span class="ml-2 text-sm font-medium text-gray-900">Chọn ngày chi</span>
                            </label>
                        </div>

                        <div class="w-full animate-popupFadeIn p-3 bg-gray-50 rounded-xl border border-gray-100 mt-2 mb-4" v-if="typePaymentStatus === '1'">
                            <div class="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                                <font-awesome-icon :icon="['fas', 'calendar-day']" class="text-brand" /> Ngày thực chi:
                            </div>
                            <div class="relative w-full">
                                <el-date-picker 
                                    v-model="nowDate" 
                                    type="date" 
                                    @change="handleDateChange"
                                    placeholder="Chọn ngày chi tiền"
                                    class="w-full h-11 custom-date-picker"
                                    popper-class="custom-date-popper-high-z">
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template slot="footer">
                <div class="w-full">
                    <button
                        class="min-w-[110px] px-4 py-2.5 text-white font-bold rounded-lg bg-brand hover:bg-brand-light shadow-[0_4px_10px_rgba(2,75,179,0.3)] hover:-translate-y-[1px] transition-all duration-200 mr-1 w-full"
                        @click="verify2FA()">Gửi xác thực OTP</button>
                </div>
            </template>
        </Popup>
    </div>
    <!-- <div 
        v-loading="loading"
        element-loading-text="Đang tải dữ liệu..." 
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.7)" 
        v-if="isShow" 
        class="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50"
        @click.self="closePopup()">
        <div class=" bg-white  rounded-lg shadow-lg  md:w-[400px] w-[95%] h-min"
            :class="{ 'animate-popupFadeIn': isVisible, 'animate-popupFadeOut': !isVisible }">
            <div class="p-2 text-[20px] float-right"><font-awesome-icon :icon="['fas', 'xmark']" class="cursor-pointer"
                    @click="closePopup()" /></div>
            <div class="p-2">
                <div class="w-full m-1">
                    <p class="sm:text-sm text-xs font-bold">Nhập mã OTP:</p>
                    <input
                        class="w-full font-bold text-gray-500 p-1 border-b-[1px] focus:border-blue-500 focus:outline-none sm:text-sm text-xs"
                        v-model="otpCode" placeholder="Nhập mã OTP trong ứng dụng Authenticator">
                </div>
                <div v-if="$app.userInfo.user_role.value === 0">
                    <div class="grid grid-cols-2 gap-4 text-sm font-medium my-4">
                        <div class="flex items-center">
                            <input type="radio" class="mr-1" value="0" v-model="typePaymentStatus"> Chi ngay
                        </div>
                        <div class="flex items-center">
                            <input type="radio" class="mr-1" value="1" v-model="typePaymentStatus"> Chọn ngày chi
                        </div>
                    </div>
                    <div class="flex flex-row my-1" v-if="typePaymentStatus == 1">
                        <div class="text-sm flex items-center ">Chọn ngày :</div>
                        <div class="block ml-1">
                            <el-date-picker v-model="nowDate" type="date" @change="handleDateChange"
                                placeholder="Pick a day">
                            </el-date-picker>
                        </div>
                    </div>
                </div>
                <div class="my-2">
                    <button
                        class="border-2 rounded-md border-blue-500 bg-blue-200 text-gray-500 sm:text-sm text-xs p-1 font-bold mr-1 md:w-auto w-full"
                        @click="verify2FA()">Gửi xác thực OTP</button>
                </div>
            </div>
        </div>
    </div> -->
</template>

<script>
import Popup from '../component/common/Popup.vue';
const API_URL = process.env.VUE_APP_API_URL
export default {
    components: {
        Popup
    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        billdetail: {
            type: Object,
            default: null
        },
        isSignMultiple: {
            type: Boolean,
            default: false
        },
        optionpropvalue: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            otpCode: '',
            isVisible: true,
            qrCode: '',
            verifyOTP: false,
            databilldetail: null,
            optionupdate: '',
            checkissetup: false,
            checkBoxData: false,
            nowDate: '',
            typePaymentStatus: 0,
            secret: '',
            loading: false,
        };
    },
    watch: {
        billdetail: {
            handler(newVal) {
                if (newVal) {
                    if (newVal !== null) {
                        this.databilldetail = newVal;
                    }
                }
            },
            deep: true,
            immediate: true
        },
        optionpropvalue: {
            handler(newVal) {
                if (newVal) {
                    if (newVal !== null) {
                        this.optionupdate = newVal;
                    }
                }
            },
            deep: true,
            immediate: true
        },
        typePaymentStatus(newVal) {
            if (newVal === '1') {
                this.$nextTick(() => {
                    const popupBody = this.$refs.popup.$refs.bodyPopup;
                    if (popupBody) {
                        popupBody.scrollTo({
                            top: popupBody.scrollHeight,
                            behavior: 'smooth'
                        });
                    }
                });
            }
        }
    },
    computed: {

    },
    mounted() {
        this.getNowDateTime()
    },
    methods: {
        handleDateChange(value) {
            this.nowDate = this.formatDate(value);
        },

        formatDate(date) {
            if (!date) return null;
            const offset = date.getTimezoneOffset() * 60000; // Chuyển offset thành milliseconds
            return new Date(date - offset).toISOString().split("T")[0]; // Lấy YYYY-MM-DD
        },
        getNowDateTime() {
            const now = new Date();
            this.nowDate = now.toISOString().slice(0, 16);
        },
        closePopup() {
            this.isVisible = false
            setTimeout(() => {
                this.$emit('closed');
            }, 200);
        },
        async setup2FA() {
            await this.$axios.put(`${API_URL}/authuserslog/setup2FA`, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Authorization': `Bearer ${this.$app.token}`,
                },
            }).then(res => {
                this.qrCode = res.data.qrCode
                this.secret = res.data.secret
                this.verifyOTP = true
            }).catch(err => {
                console.log(err)
                this.$notify.error({
                    title: 'Thất bại',
                    message: 'Xảy ra lỗi khi thiết lập 2FA.'
                });
            });

        },
        async verify2FA() {
            await this.$axios.post(`${API_URL}/authuserslog/verify2FA`, {
                token: this.otpCode,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Authorization': `Bearer ${this.$app.token}`,
                },
            }).then(async res => {
                if (res.status === 200) {
                    this.$notify.success({
                        title: 'Thành công',
                        message: 'Xác thực thành công.'
                    });
                    if(this.isSignMultiple) {
                        await this.signMultipleBill();
                    } else {
                        if (this.$app.userInfo.user_role.value === 0) {
                            this.updateStatusPayment(this.databilldetail.id)
                        }
                        this.closePopup()
                        this.$emit('update', this.databilldetail, this.optionupdate);
                    }
                }
            }).catch(err => {
                console.log(err)
                this.$notify.error({
                    title: 'Thất bại',
                    message: 'Mã xác thực không đúng, vui lòng thử lại'
                });
            });

        },
        copySecret() {
            if (!this.secret) return;
            navigator.clipboard.writeText(this.secret).then(() => {
                this.$notify.success({
                    title: 'Đã sao chép!',
                    message: 'Mã bí mật đã được chép vào khay tiếp nhớ.',
                    duration: 2000
                });
            }).catch(err => {
                console.error("Lỗi khi copy: ", err);
            });
        },
        async updateStatusPayment(id) {
            const data = {
                approvePaymentDate: this.nowDate,
                approvePaymentStatus: 1,
                payNow: this.typePaymentStatus
            };

            await this.$axios.put(`${API_URL}/bills/update/${id}`, {
                type: 'paymentStatus',
                data
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Authorization': `Bearer ${this.$app.token}`,
                },
            }).then(res => {
                this.$notify.success({
                    title: 'Thành công',
                    message: 'Cập nhật trạng thái thành công.'
                });
                this.closePopup();
                this.$emit('reload');
            }).catch(err => {
                console.log(err);
                this.$notify.error({
                    title: 'Thất bại',
                    message: 'Xảy ra lỗi khi cập nhật trạng thái.'
                });
            })
        },
        async signMultipleBill() {
            this.loading = true
            let filterBillByStatus = this.$app.multipleSelection.filter(el => el.status != 0)
            let selectedDate = {
                approvePaymentDate: this.nowDate,
                approvePaymentStatus: 1,
                payNow: this.typePaymentStatus
            }
            await this.$axios.post(`${API_URL}/bills/sign-multiple-bill`, {
                data: filterBillByStatus,
                selectedDate: selectedDate
            },{
                headers: {
                    'Content-Type': 'application/json',
                    'X-Authorization': `Bearer ${this.$app.token}`,
                },
            }).then(res => {
                if(res.data.success) {
                    this.$notify.success({
                        title: 'Thành công',
                        message: res.data.message
                    });
                }
                this.loading = false
                this.closePopup()
            }).catch(err => {
                console.log(err)
                this.loading = false
                this.$notify.error({
                    title: 'Thất bại',
                    message: 'Xảy ra lỗi khi cập nhật trạng thái.'
                });
            });
        }

    }
};
</script>

<style scoped>
@keyframes popupFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes popupFadeOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(10px);
    }
}

.animate-popupFadeIn {
    animation: popupFadeIn 0.5s forwards;
}

.custom-date-picker ::v-deep(.el-input__inner) {
    height: 44px;
    line-height: 44px;
    border-radius: 0.5rem;
    border: 1px solid #e5e7eb;
    background-color: #ffffff;
    font-weight: 500;
    color: #374151;
    transition: all 0.2s ease;
}

.custom-date-picker ::v-deep(.el-input__inner:focus) {
    border-color: var(--color-brand);
    box-shadow: 0 0 0 2px rgba(2, 75, 179, 0.2);
}

.custom-date-picker ::v-deep(.el-input__prefix) {
    color: var(--color-brand);
}
</style>

<style>
.custom-date-popper-high-z {
    z-index: 999999 !important;
}

.animate-popupFadeOut {
    animation: popupFadeOut 0.5s forwards;
}
</style>